export enum LEXOFFICE_BILLING_LANGUAGE {
  DE = 'de',
  EN = 'en',
}
